/**
 * axios setup to use mock service
 */

import axios from 'axios';

const baseURL = process.env.NODE_ENV == "development" ? 'http://localhost:3001/' : process.env.REACT_APP_API_URL;
const axiosServices = axios.create({ baseURL });

// interceptor for http
axiosServices.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject((error.response && error.response.data) || 'Wrong Services')
);

export default axiosServices;
